export default "__VITE_ASSET__f5a4c84b__"